import * as React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export interface IModalMessageProps {
    isOpen: boolean;
    modalHeader: string;
    modalBody: string;
    children?: React.ReactNode;
    onClickYes: () => void;
    onClickNo: () => void;
}

export const ModalMessage = (props: IModalMessageProps) => {
    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader>{props.modalHeader}</ModalHeader>
            <ModalBody>
                {props.modalBody}
                {props.children}
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-danger w-50" onClick={props.onClickYes}>
                    Ja
                </button>
                <button className="btn btn-primary w-50" onClick={props.onClickNo}>
                    Nein
                </button>
            </ModalFooter>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/modalMessage/ModalMessage.tsx